const selectCollab = (state) => state.collab;

export const selectCurrentRoom = (state) => selectCollab(state).currentRoom;
export const selectRole        = (state) => selectCollab(state).role;
export const selectIsRoomJoined = (state) => selectCollab(state).currentRoom != null;
export const selectLastUnauthorizedReason = (state) => selectCollab(state).lastUnauthorizedReason;

// Convenience: backend doc §7.1 — `edit | admin | owner` can mutate the
// doc; `view | comment` are read-only.
export const selectCanEditDoc = (state) => {
    const role = selectRole(state);
    return role === 'edit' || role === 'admin' || role === 'owner';
};
